<div class="layout-container">
    <ols-header></ols-header>
    <div class="router-outlet-container">
        <div class="router-outlet-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
